export const loginConstants = {
    LOADING: 'LOADING_LOGIN',
    ERROR: 'ERROR_LOGIN',
    UPDATED: 'PROFILE_UPDATED',
    GENERATE_CODE: 'GENERATE_CODE_LOGIN',
    STEP: 'STEP_LOGIN',
    LOGIN: 'LOGIN_LOGIN',
    CLEAR: 'CLEAR_LOGIN'
}